import useGet from "api/useGet";
import * as fatchSet from "../../api/api";
import React, { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentsSection, PageTitle } from "component/app/items";
import { Footer } from "component/elements/footer";
import { Header } from "component/elements/header";
import { LoadingBox } from "component/basic/popup";
import { FixedPage, FixedSection } from "component/basic";
import { NotItems } from "component/basic/notItems";
import { FixedContents } from "component/product/page";
import { MypageControll } from "component/mypage/items";
import {BoardListBox, BoardListItem, CsControll, FaqControll} from "component/board/items";

const Insurance = (props) => {
    const navigate = useNavigate();

    const [loadingBoxOpen,setLoadingBoxOpen] =  useState(true);

    const pageDataApi = useGet({
        url:`/notice?type=insurance`,
        loginType:"login"
    });
    const pageData = pageDataApi?.data?.notices;

    useEffect(() => {
        setLoadingBoxOpen(false);
    }, []);

    return (
        <>
            <ContentsSection
                header={true}
                footer={true}
                addClass={"gBg"}
            >
                <Header
                    addClass=""
                    logo={false}
                    mMenu={false}
                    pageBack={true}
                    func={()=>{navigate(-1)}}
                    headTitle={"자차(면책)제도"}
                    rightBtnsArr={null}
                    pageClose={false}
                    activeType={3}
                    closeFunc={()=>{}}
                />
                <FixedPage addClass="reverse mnReverse">
                    <FaqControll boxAddClass="pcItemT"/>
                    <FixedContents>
                        <PageTitle
                            addClass="fixedContents_title pcItemT"
                            pageBack={null}
                            contents="자차(면책)제도"
                        />
                        <BoardListBox addClass="noticeListBox">
                            {pageData && pageData?.length > 0 ? 
                                <>
                                    {pageData && pageData?.map((item, i) => (
                                        <BoardListItem
                                            key={i}
                                            type="notice"
                                            data={item}
                                        />
                                    ))}
                                </>
                            :
                                <NotItems addClass="fullPage" text={`자차(면책)제도가 없습니다.`}/>
                            }
                        </BoardListBox>
                    </FixedContents>
                </FixedPage>
            </ContentsSection>
            <Footer/>
            <LoadingBox openType={loadingBoxOpen}/>
        </>
    );
};

export default Insurance;